import { useEffect, useState } from "react";
import { api, ApiError } from "../api";
import type { User } from "../types";

export function Login({ onLogin }: { onLogin: (user: User) => void }) {
	const [userId, setUserId] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [busy, setBusy] = useState(false);
	const [waitLeft, setWaitLeft] = useState(0);

	// Count the lockout down locally. Leaving the button live during it just feeds the
	// limiter more failures and pushes the unlock further away.
	useEffect(() => {
		if (waitLeft <= 0) return;
		const timer = setTimeout(() => setWaitLeft((s) => s - 1), 1000);
		return () => clearTimeout(timer);
	}, [waitLeft]);

	async function submit(e: React.FormEvent) {
		e.preventDefault();
		setBusy(true);
		setError(null);
		try {
			const { user } = await api.login(userId.trim(), password);
			onLogin(user);
		} catch (err) {
			if (err instanceof ApiError && err.isThrottled) {
				setWaitLeft(err.retryAfter ?? 60);
				setError("失败次数太多，先等一会儿");
			} else {
				setError(err instanceof ApiError ? err.message : "登录失败");
			}
		} finally {
			setBusy(false);
		}
	}

	return (
		<div className="login">
			<form onSubmit={submit}>
				<h1>hifi agent</h1>
				<label>
					账号
					<input value={userId} onChange={(e) => setUserId(e.target.value)} autoComplete="username" autoFocus required />
				</label>
				<label>
					密码
					<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
				</label>
				{error && (
					<p className="error">
						{error}
						{waitLeft > 0 && ` —— ${waitLeft} 秒后可以再试`}
					</p>
				)}
				<button type="submit" disabled={busy || !userId || !password || waitLeft > 0}>
					{busy ? "登录中…" : waitLeft > 0 ? `等 ${waitLeft} 秒` : "登录"}
				</button>
			</form>
		</div>
	);
}
